// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import TranslateBadge from '../_raw/ui/icon_translate_badge.svg';
import withIconProps from '../withIconProps';

export default withIconProps(TranslateBadge, {
  shouldSetDefaultSize: true,
  defaultWidth: 120,
  defaultHeight: 16,
});
